package net.gorillagroove.history

import kotlinx.serialization.Serializable
import net.gorillagroove.api.Api
import net.gorillagroove.api.UserId
import net.gorillagroove.hardware.DeviceType
import net.gorillagroove.hardware.RawDeviceType

// TODO this entire thing is very subject to change. I just made this for GG's 2023 wrap-up,
//  but I plan to add more stats and not allow you to look at other user's stats and crap.
//  Right now it's locked down on the backend to only allow my own user to access this
object SiteStats {
    @Throws(Throwable::class)
    suspend fun getSiteStats(): SiteWideStatsResponse {
        return Api.get("track-history/test")
    }

    @Throws(Throwable::class)
    suspend fun getYearSummary(userId: UserId, year: Int, accessToken: String?): UserStatsResponse {
        return Api.get("track-history/year-wrap-up/$year/${userId.value}", anonymousAccessToken = accessToken)
    }
}

@Serializable
data class SiteWideStatsResponse(
    val playtimeByUser: List<LongByStringStat>,
    val playtimeByDevice: List<PlaytimeByDeviceTypeStat>,
    val playCountByUser: List<LongByStringStat>,
)
@Serializable
data class UserStatsResponse(
    val username: String,
    val totalTimeListened: Int, // Seconds
    val totalTracksListened: Int, // Seconds
    val newTrackCount: Int,
    val uniqueTracksListened: Int,
    val playtimePlacement: Int, // 1 = 1st place, 2 = 2nd place, etc
    val playtimePercent: Double, // A number between 0.0-1.0 representing what percent of all GG play time was yours
    val timeListenedByDeviceType: Map<DeviceType, Int>,
    val mostListenedTracks: Map<String, Int>,
    val mostListenedArtists: Map<String, Int>,
    val mostListenedAlbums: Map<String, Int>,
    val distanceTraveled: Double,
    val timeListeningByDay: List<Int>, // Seconds for each day, starting with Sunday
    val timeListeningByMonth: List<Int>, // Seconds for each month, starting with January
    val timeListeningByHour: List<Int>, // Seconds for each hour, starting with Midnight
)

@Serializable
data class LongByStringStat(
    val longStat: Long,
    val stringStat: String,
)
@Serializable
data class PlaytimeByDeviceTypeStat(
    val playtime: Long,
    val deviceType: RawDeviceType,
)
